module.exports = __webpack_public_path__ + "static/media/angle-down.3b33059f.svg";